import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  ListGroup,
  ListGroupItem,
  CardTitle
} from "reactstrap";

class Help extends Component {
  render() {
    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>
            <CardTitle className="mb-0">Ayuda</CardTitle>
          </CardHeader>
          <CardBody>
            <ListGroup>
              <ListGroupItem className="justify-content-between">
                <div className="d-flex w-100 justify-content-between">
                  <h5 className="mb-1">¿Pregunta 1?</h5>
                </div>
                <p className="mb-1">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum
                  passages, and more recently with desktop publishing software
                  like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
                <small />
              </ListGroupItem>
              <ListGroupItem className="justify-content-between">
                <div className="d-flex w-100 justify-content-between">
                  <h5 className="mb-1">¿Pregunta 2?</h5>
                </div>
                <p className="mb-1">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum
                  passages, and more recently with desktop publishing software
                  like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
                <small />
              </ListGroupItem>
            </ListGroup>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default Help;
